import styled from 'styled-components';

export const TransparentInput = styled.input`
    width: 100%;
    height: 100%;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    background: none;
    border: none;
    outline: none;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/InvisibleInput/style.js